import React from "react";

const SubmittedIcon = ({ cls }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_3310_53154)">
        <path
          d="M20.7802 5.76669L17.1511 2.13544C16.4754 1.45642 15.6718 0.918077 14.7867 0.551544C13.9017 0.185011 12.9528 -0.00244154 11.9948 2.4009e-05H7.29171C5.91088 0.00167803 4.58708 0.550943 3.61069 1.52734C2.63429 2.50373 2.08503 3.82753 2.08337 5.20836V19.7917C2.08503 21.1725 2.63429 22.4963 3.61069 23.4727C4.58708 24.4491 5.91088 24.9984 7.29171 25H17.7084C19.0892 24.9984 20.413 24.4491 21.3894 23.4727C22.3658 22.4963 22.9151 21.1725 22.9167 19.7917V10.9219C22.9193 9.96401 22.7318 9.01512 22.3651 8.13021C21.9983 7.24529 21.4597 6.44194 20.7802 5.76669ZM19.3073 7.23961C19.6254 7.56684 19.899 7.9346 20.1209 8.33336H15.625C15.3488 8.33336 15.0838 8.22361 14.8885 8.02826C14.6931 7.83291 14.5834 7.56796 14.5834 7.29169V2.79586C14.9823 3.01765 15.3503 3.29082 15.6782 3.60836L19.3073 7.23961ZM20.8334 19.7917C20.8334 20.6205 20.5041 21.4153 19.9181 22.0014C19.332 22.5875 18.5372 22.9167 17.7084 22.9167H7.29171C6.46291 22.9167 5.66805 22.5875 5.082 22.0014C4.49595 21.4153 4.16671 20.6205 4.16671 19.7917V5.20836C4.16671 4.37956 4.49595 3.5847 5.082 2.99865C5.66805 2.4126 6.46291 2.08336 7.29171 2.08336H11.9948C12.1657 2.08336 12.3313 2.11669 12.5 2.13232V7.29169C12.5 8.12049 12.8293 8.91535 13.4153 9.5014C14.0014 10.0875 14.7962 10.4167 15.625 10.4167H20.7844C20.8 10.5854 20.8334 10.75 20.8334 10.9219V19.7917Z"
          fill="currentColor"
        />
        <path
          d="M10.7288 19.6095C10.445 19.6096 10.1727 19.4968 9.97219 19.2959L7.68461 17.0092C7.43846 16.7629 7.43846 16.3638 7.68461 16.1176C7.93083 15.8714 8.32996 15.8714 8.57618 16.1176L10.7288 18.2702L16.4238 12.5752C16.67 12.3291 17.0692 12.3291 17.3154 12.5752C17.5615 12.8215 17.5615 13.2206 17.3154 13.4668L11.4855 19.2959C11.2849 19.4968 11.0127 19.6096 10.7288 19.6095Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3310_53154">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SubmittedIcon;
